import {
  Component,
  computed,
  inject,
  signal,
  input,
  output
} from '@angular/core';
import { Hex } from 'viem';
import { LobbyController } from '../../services/lobby-controller';
import { ServerService } from '../../services/server.service';
import { Wallet } from '../../services/wallet';
import { OnlineUser } from '../../types/server';
import {
  DirectChallengeRequest,
  OnlinePlayerRowComponent,
} from '../online-player-row/online-player-row.component';

@Component({
  selector: 'app-online-players-sidebar',
  imports: [OnlinePlayerRowComponent],
  templateUrl: './online-players-sidebar.component.html',
  styleUrl: './online-players-sidebar.component.css',
})
export class OnlinePlayersSidebarComponent {
  private readonly server = inject(ServerService);
  private readonly wallet = inject(Wallet);

  readonly challengePending = input<Hex | null>(null);
  readonly defaultMode = input(0);

  readonly challenge = output<DirectChallengeRequest>();
  readonly editSelf = output<void>();

  readonly searchText = signal<string>('');

  readonly selfAddress = computed<Hex | null>(
    () => (this.wallet.walletAddress() ?? null) as Hex | null,
  );

  readonly selfUser = computed<OnlineUser>(() => {
    const addr = this.selfAddress();
    if (addr) {
      const entry = this.server.clientFor(addr);
      if (entry) return entry;
    }
    return { username: this.wallet.username() ?? '' };
  });

  readonly otherPlayers = inject(LobbyController).otherPlayers;

  readonly visibleOthers = computed(() => {
    const search = this.searchText().toLowerCase().trim();
    const all = this.otherPlayers();
    if (!search) return all;
    return all.filter(
      ({ address, user }) =>
        user.username.toLowerCase().includes(search) ||
        (user.twitterHandle?.toLowerCase().includes(search) ?? false) ||
        address.toLowerCase().includes(search),
    );
  });

  readonly onlineCount = computed(
    () => this.otherPlayers().length + (this.selfAddress() ? 1 : 0),
  );
}
